import React, { useEffect, useState } from 'react'
import './App.css'
import { CssBaseline, Box, Toolbar, IconButton } from '@mui/material'
import { Menu as MenuIcon, ChevronLeft as ChevronLeftIcon } from '@mui/icons-material'
import CustomBreadcrumbs from './components/breadcrumb/CustomBreadCrumbs'
// import { logOut } from './auth/authSlice'
// import { useDispatch } from 'react-redux'
import { Outlet, useNavigate } from 'react-router-dom'
import MuiAppBar from '@mui/material/AppBar';
import MuiDrawer from '@mui/material/Drawer';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import AccountSelect from './components/account-select/AccountSelect'
import UserMenu from './components/user-menu/UserMenu'
import LanguageSelector from './components/user-menu/LanguageSelector'
import NavigationItems from './components/navigation-items/NavigationItems'
import ContainerI18nWrapper from './i18n/I18nWrapper'
// import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import NavigationIcons from './components/navigation-items/NavigationIcons'
import Collapse from '@mui/material/Collapse';
import DoDisturbOnRoundedIcon from '@mui/icons-material/DoDisturbOnRounded';

const drawerWidth = 300;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  // zIndex: theme.zIndex.drawer + 1,
  // zIndex: 1300,
  backgroundColor: theme.palette.mode === 'light' ? '#FCFCFC' : theme.palette.grey[900],
  backgroundColor: 'transparent',
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    // marginLeft: drawerWidth,
    // width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      backgroundColor: theme.palette.mode === 'light' ? '#F5F5F5' : 'hsl(0, 0%, 7%)',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(7),
        },
      }),
    },
  }),
);

const getPersistedMode = () => {
  const savedMode = localStorage.getItem('mode');
  return savedMode ? savedMode : 'light';
};

function App() {
  const [open, setOpen] = useState(true);
  const [mode, setMode] = useState(getPersistedMode);
  const defaultTheme = createTheme({
    palette: {
      mode, 
    },
    components: {
      MuiDrawer: {
        styleOverrides: {
          paper: ({theme}) => ({
            backgroundColor:
              theme.palette.mode === 'light' ? '#FCFCFC' : '#000000',
          }),
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 8
          }
        }
      }
    },
  });
  // const dispatch = useDispatch()
  // const navigate = useNavigate()

  // const handleLogOut = () => {
  //   dispatch(logOut())
  //   navigate('/sign-in')
  // }

  const toggleColorMode = () => {
    setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  useEffect(() => {
    localStorage.setItem('mode', mode);
  }, [mode]);

  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <ContainerI18nWrapper>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        {/* <AppBar elevation={0} position="absolute" open={open}>
          <Toolbar
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              fontSize="small"
              sx={{
                marginRight: 4,
                transition: '0.3s',
                display: open && 'none',
                borderRadius: 1
              }}
            >
              <MenuIcon fontSize="small" sx={{ color: mode === 'light' ? 'black' : 'white'}}/>
            </IconButton>
            <IconButton
                edge="start"
                color="inherit"
                aria-label="open drawer"
                onClick={toggleDrawer}
                fontSize="small"
                sx={{
                  marginRight: 1,
                  display: !open && 'none',
                  borderRadius: 1
                }}>
              <ChevronLeftIcon fontSize="small" sx={{ color: mode === 'light' ? 'black' : 'white'}}/>
            </IconButton>

            <CustomBreadcrumbs /> 
            <AccountSelect openDrawer={setOpen} />
              
            <LanguageSelector />
            <UserMenu mode={mode} toggleColorMode={toggleColorMode} logOut={handleLogOut}/>
            

          </Toolbar>
        </AppBar> */}
        <Drawer variant="permanent" open={open}>
          {/* <Toolbar
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              // px: [1],
            }}
          >
          </Toolbar> */}
          {open ?
          <Collapse orientation="horizontal" in={open}>
             {/* <CustomBreadcrumbs /> */}
            <NavigationItems/>
          </Collapse>

            : 
            <NavigationIcons/>
          }
        </Drawer>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? '#FCFCFC'
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            padding: 0,
            margin: 0,
            overflow: 'auto',
          }}
        >
            <AppBar elevation={0} position="static" open={open}>
          <Toolbar
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              fontSize="small"
              sx={{
                marginRight: 1,
                transition: '0.3s',
                display: open && 'none',
                borderRadius: 1
              }}
            >
              <MenuIcon fontSize="small" sx={{ color: mode === 'light' ? 'black' : 'white'}}/>
            </IconButton>
            <IconButton
                edge="start"
                color="inherit"
                aria-label="open drawer"
                onClick={toggleDrawer}
                fontSize="small"
                sx={{
                  marginRight: 1,
                  transition: '0.3s',
                  display: !open && 'none',
                  borderRadius: 1
                }}>
              <ChevronLeftIcon fontSize="small" sx={{ color: mode === 'light' ? 'black' : 'white'}}/>
            </IconButton>

            <CustomBreadcrumbs /> 
            <AccountSelect openDrawer={setOpen} />
              
            {/*<LanguageSelector />*/}
            <UserMenu mode={mode} toggleColorMode={toggleColorMode} />
            

          </Toolbar>
        </AppBar>
          {/* <Toolbar/>  */}
          <Outlet />
        </Box>
      </Box>
      </ContainerI18nWrapper>
    </ThemeProvider>
  )
}

export default App
